export default __webpack_public_path__ + "static/wtu_small-e9e3e28dd2e0c7d24ac6bbb9f2d5a17a.jpg";